<template>
  <div>
    <div
      v-if="restaurant.settings.header"
      class="hero"
      :style="`background: url('https://app.restorani.bitlab.host/gallery/${restaurant.id}/medium/${restaurant.settings.header}'); background-size: cover; background-position: center;`"
    >
      <img
        class="hero-logo"
        :src="
          conf.apiUrlBase + '/gallery/' + restaurant.id + '/' + restaurant.settings.logo
        "
      />
    </div>
    <v-container>
      <v-row class="mt-5" align="center" justify="center">
        <v-card align="center" justify="center" width="400px">
          <v-card-title>
            <v-row align="center" justify="center">{{ toLatin(restaurant.name) }}</v-row>
          </v-card-title>
          <v-card-text align="center" justify="center">
            {{ toLatin(restaurant.address) }}
          </v-card-text>
          <v-divider class="ma-1"></v-divider>
          <v-card-text align="center" justify="center">
            <v-icon class="mr-1" color="red" small>mdi-cellphone</v-icon>
            {{ translate(restaurant.phone) }}
          </v-card-text>

          <v-card-text align="center" justify="center">
            <v-icon class="mx-1" color="red" small>mdi-email</v-icon>
            {{ restaurant.email }}
          </v-card-text>

          <v-divider></v-divider>

          <v-card-text align="center" justify="center">
            <a
              :href="restaurant.settings.website"
              target="_blank"
              style="text-decoration: none"
            >
              <strong>{{ restaurant.settings.website }}</strong>
            </a>
          </v-card-text>

          <v-row
            class="mx-0 my-2"
            align="center"
            justify="center"
            v-if="icons.some((icon) => restaurant.settings[icon.type] != null)"
          >
            <v-btn
              v-for="icon in icons"
              :key="icon.type"
              class="my-3 black--text"
              icon
              :href="restaurant.settings[icon.type]"
              target="_blank"
            >
              <v-icon color="red" size="24px">
                {{ icon.icon }}
              </v-icon>
            </v-btn>
          </v-row>
        </v-card>
      </v-row>

      <p class="text-center mb-0 mt-12 pb-0 mb-2">
        <strong>{{ $t("support_and_info") }}</strong>
      </p>
      <p class="text-center mb-0 pb-0">
        {{ $t("phone_viber_1") }}<a href="tel:+38766516174">+38766516174</a>,
        <a href="tel:+38765021012">+38765021012</a>
      </p>
      <p class="text-center mb-0 pb-0">
        help desk: <a href="mailto:help@ordera.app">help@ordera.app</a>
      </p>
    </v-container>
    <!-- Footer Start -->
    <footer class="footer-section mt-8">
      <v-container>
        <v-row class="footer-row" align="start" justify="space-between">
          <v-col
            cols="12"
            md="3"
            class="footer-logo-col mb-4 mb-md-0 text-center text-md-left"
          >
            <img
              style="width: 200px"
              src="https://topli-obrok.ordera.app/images/food/logo.png"
              alt="Ordera logo"
              class="footer-logo mb-4"
            />
            <v-row
              no-gutters
              class="footer-apps d-flex flex-row justify-center justify-md-start"
            >
              <a
                v-for="image in mobile"
                :key="image.type"
                href="https://apps.apple.com/"
                target="_blank"
                v-if="restaurant.settings[image.type] != null"
                :href="restaurant.settings[image.type]"
                class="mr-2"
              >
                <img class="footer-app-btn" :src="image.image" alt="" />
              </a>
            </v-row>
          </v-col>
          <v-col cols="12" md="3" class="mb-4 mb-md-0">
            <h3 class="footer-title">{{ $t("let_s_do_it_together") }}</h3>
            <ul class="footer-list">
              <li>
                <a href="#">{{ $t("employment") }}</a>
              </li>
              <li>
                <a href="https://partner.ordera.app/lat/?lang=lat">{{
                  $t("ordera_for_partners")
                }}</a>
              </li>
              <li>
                <a href="https://topli-obrok.ordera.app/lat/" target="_blank">{{
                  $t("ordera_for_companies")
                }}</a>
              </li>
              <li>
                <a href="https://ordera.app/" target="_blank">{{
                  $t("private_orders")
                }}</a>
              </li>
              <li>
                <a href="https://konobar.ordera.app/info/lat/" target="_blank">{{
                  $t("digital_menu")
                }}</a>
              </li>
            </ul>
          </v-col>
          <v-col cols="12" md="3" class="mb-4 mb-md-0">
            <h3 class="footer-title">{{ $t("important_links") }}</h3>
            <ul class="footer-list">
              <li>
                <a href="#">{{ $t("about_us") }}</a>
              </li>
              <li>
                <a href="https://posao.ordera.app/lat/" target="_blank">{{
                  $t("faq")
                }}</a>
              </li>
              <li>
                <a
                  href="https://topli-obrok.ordera.app/lat/kontakt.php"
                  target="_blank"
                  >{{ $t("contact_us") }}</a
                >
              </li>
              <li>
                <a href="https://help.ordera.app/lat/" target="_blank">{{
                  $t("technical_support")
                }}</a>
              </li>
            </ul>
          </v-col>
          <v-col cols="12" md="3">
            <h3 class="footer-title">{{ $t("follow_us") }}</h3>
            <ul class="footer-list">
              <li>
                <a href="https://www.facebook.com/orderaobrok" target="_blank">{{
                  $t("facebook")
                }}</a>
              </li>
              <li>
                <a href="https://www.instagram.com/ordera_meal/" target="_blank">{{
                  $t("instagram")
                }}</a>
              </li>
            </ul>
          </v-col>
        </v-row>
        <v-divider class="my-4"></v-divider>
        <v-row justify="center" class="footer-bottom text-center">
          <v-col cols="12">
            <a href="https://privacy.ordera.app/" target="_blank">
              <span class="footer-bottom-link">{{ $t("privacy_policy") }}</span>
            </a>
          </v-col>
        </v-row>
        <p class="text-center footer-bottom mt-2 mb-0">
          &copy; {{ new Date().getFullYear() }}
          <a href="https://bitlab.rs/" target="_blank" style="text-decoration: none">
            <strong>{{ $t("bitlab") }}</strong>
          </a>
          {{ $t("all_rights_reserved") }}
        </p>
      </v-container>
    </footer>
    <!-- Footer End -->
  </div>
</template>
<script>
import conf from "../config";
export default {
  data: () => ({
    conf: conf,
    icons: [
      { icon: "mdi-facebook", type: "facebook" },
      { icon: "mdi-twitter", type: "twitter" },
      { icon: "mdi-linkedin", type: "linkedin" },
      { icon: "mdi-instagram", type: "instagram" },
    ],
    mobile: [
      {
        image: "https://app.restorani.bitlab.host/gallery/60/LBca_playstore.png",
        type: "google",
      },
      {
        image: "https://app.restorani.bitlab.host/gallery/60/NhQp_appstore.png",
        type: "apple",
      },
      {
        image: "https://app.restorani.bitlab.host/gallery/64/huawei.png",
        type: "huawei",
      },
    ],
  }),
  methods: {
    switchDay(dani) {
      let dan = "";

      if (dani == "Понедељак") {
        dan = "Понедељакa";
      }
      if (dani == "Уторак") {
        dan = "Уторкa";
      }
      if (dani == "Среда") {
        dan = "Средe";
      }
      if (dani == "Четвртак") {
        dan = "Четврткa";
      }
      if (dani == "Петак") {
        dan = "Петкa";
      }
      if (dani == "Субота") {
        dan = "Суботe";
      }
      if (dani == "Недеља") {
        dan = "Недељe";
      }
      return dan;
    },
  },
  computed: {
    restaurant() {
      return this.$store.state.restaurant
        ? this.$store.state.restaurant
        : this.$store.state.company.restaurant;
    },
  },
};
</script>

<style scoped>
.logo-info {
  width: 100%;
  object-fit: contain;
}
.footer-section {
  background: #232328;
  color: #fff;
  padding: 48px 0 0 0;
  width: 100%;
  position: absolute;
  bottom: 0;
}

@media screen and (max-width: 1200px) {
  .footer-section {
    position: relative;
  }
}
.footer-logo {
  width: 160px;
  margin-bottom: 16px;
}
.footer-apps .footer-app-btn {
  width: 120px;
  margin-right: 8px;
  margin-bottom: 8px;
}
.footer-title {
  font-size: 1.25rem;
  font-weight: 700;
  margin-bottom: 16px;
}
.footer-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.footer-list li {
  margin-bottom: 8px;
}
.footer-list a {
  color: #fff;
  text-decoration: none;
  transition: color 0.2s;
}

.footer-bottom a {
  text-decoration: none;
  color: #aaa;
}
.footer-list a:hover {
  color: #e53935;
}
.footer-bottom {
  font-size: 0.95rem;
  color: #aaa;
}
.footer-bottom-link {
  margin: 0 16px;
  cursor: pointer;
}
@media (max-width: 960px) {
  .footer-section {
    padding: 32px 0 0 0;
  }
  .footer-row {
    flex-direction: column !important;
    align-items: center !important;
    gap: 24px;
  }
  .footer-logo-col {
    text-align: center !important;
    margin-bottom: 24px !important;
  }
  .footer-apps {
    justify-content: center !important;
    flex-wrap: wrap;
    margin-bottom: 16px;
  }
  .footer-title {
    text-align: center;
    margin-bottom: 12px;
  }
  .footer-list {
    text-align: center;
    margin-bottom: 16px;
  }
  .footer-bottom {
    font-size: 1rem;
    padding-bottom: 16px;
  }
  .footer-bottom-link {
    margin: 0 8px;
    display: inline-block;
  }
}
@media (max-width: 600px) {
  .footer-section {
    padding: 24px 0 0 0;
  }
  .footer-logo {
    width: 120px;
  }
  .footer-apps .footer-app-btn {
    width: 90px;
  }
  .footer-title {
    font-size: 1.1rem;
  }
}
@media screen and (min-width: 960px) and (max-width: 1200px) {
  .footer-section {
    padding: 36px 0 0 0;
  }
  .footer-row {
    flex-wrap: wrap;
    flex-direction: row !important;
    justify-content: center !important;
    gap: 32px;
  }
  .footer-logo-col {
    text-align: left !important;
    margin-bottom: 0 !important;
  }
  .footer-logo {
    width: 140px;
  }
  .footer-apps .footer-app-btn {
    width: 100px;
  }
  .footer-title {
    font-size: 1.15rem;
    margin-bottom: 10px;
    text-align: left;
  }
  .footer-list {
    text-align: left;
    margin-bottom: 10px;
  }
  .footer-bottom {
    font-size: 1rem;
    padding-bottom: 18px;
  }
  .footer-bottom-link {
    margin: 0 10px;
  }
}
</style>
